import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import Crud from "../Crud";

function VoidReason() {
  return (
    <Crud
      title="Void Reason"
      getUrl={() => "/Wager/VoidReason_GetList"}
      // INSERT
      insertUrl={() => "/Wager/VoidReason_Insert"}
      insertParams={({ userId }, { voidReason }) => ({
        VoidReason: voidReason,
        IdUser: Number(userId),
      })}
      // UPDATE
      updateUrl={() => "/Wager/VoidReason_Update"}
      updateParams={({ userId }, { idVoidReason, voidReason }) => ({
        IdVoidReason: idVoidReason,
        VoidReason: voidReason,
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={() => "/Wager/VoidReason_Delete"}
      deleteParams={(_, id) => ({
        IdVoidReason: id,
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idVoidReason"
      >
        Id
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="voidReason"
        filter={{ type: "TextFilter", delay: 1000 }}
      >
        Reason
      </TableHeaderColumn>
    </Crud>
  );
}

export default VoidReason;
